import * as CL from '@design-system/component-library';
import * as React from 'react';
import { searchMsg, t } from '../../common/i18n/index.js';
import { getSelectedFilterCount } from '../../common/utils/productListUtilsCoCo.js';
import {
  ProductGridFilterCoCo,
  ProductGridFilterHeaderCoCo,
  ProductGridFilterStatusCoCo,
} from './ProductGridFilterCoCo.js';
import { ProductGridFilterTagsCoCo } from './ProductGridFilterTagsCoCo.js';
import { ProductGridSearchCoCo } from './ProductGridSearchCoCo.js';
import { ProductGridSortCoCo } from './ProductGridSortCoCo.js';
import { hasActiveFilters } from './productGridFilterUtilsCoCo.js';
import type { Filters } from './ProductGridFilterCoCo.js';
import type { SortType } from './ProductGridSortCoCo.js';

interface ProductGridHeaderCoCoProps {
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  setSort: React.Dispatch<React.SetStateAction<SortType>>;
  filters: Filters;
  search: string;
  sort: SortType;
}

export const ProductGridHeaderCoCo = ({
  setSearch,
  search,
  filters,
  setFilters,
  setSort,
  sort,
}: ProductGridHeaderCoCoProps) => {
  const [isFilterExpanded, setIsFilterExpanded] = React.useState(false);
  const selectedFilterCount = getSelectedFilterCount(filters);

  return (
    <>
      <CL.Grid>
        <CL.GridRow className="of-product-grid-header">
          <CL.GridCol colWidthL={3} colWidthM={2} colWidthS={6} colWidthXS={4}>
            <ProductGridSearchCoCo placeholder={t.VQE6(searchMsg)} onChange={setSearch} value={search} />
          </CL.GridCol>
          {hasActiveFilters(filters) && (
            <>
              <CL.GridCol
                colWidthL={3}
                colWidthM={2}
                colWidthS={6}
                colWidthXS={4}
                className="of-product-grid__filter-header"
              >
                <ProductGridFilterHeaderCoCo onChange={setIsFilterExpanded} value={isFilterExpanded} />
              </CL.GridCol>
              <CL.GridCol
                colWidthL={3}
                colWidthM={2}
                colWidthS={6}
                colWidthXS={4}
                className="of-product-grid__filter-status"
              >
                <ProductGridFilterStatusCoCo filters={filters} setFilters={setFilters} />
              </CL.GridCol>
            </>
          )}
          <CL.GridCol colWidthL={3} colWidthM={2} colWidthS={6} colWidthXS={4} className="of-product-grid__sort">
            <ProductGridSortCoCo onChange={setSort} selectedValue={sort} />
          </CL.GridCol>
        </CL.GridRow>
      </CL.Grid>

      {selectedFilterCount > 0 && <ProductGridFilterTagsCoCo filters={filters} setFilters={setFilters} />}
      {isFilterExpanded && (
        <div className="of-product-grid__filter-content">
          <ProductGridFilterCoCo filters={filters} onChange={setFilters} onClose={() => setIsFilterExpanded(false)} />
        </div>
      )}
    </>
  );
};
